import React, {useState, useRef, useEffect} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import Input from "../forms/Input";
import Button from "../Button";
import _ from "lodash";
import ArchiveSiteModal from "../../modals/ArchiveSiteModal";

const SITE_DEFAULTS = {
    name:                       "",
    address_line_1:             "",
    address_line_2:             "",
    address_line_3:             "",
    town_city:                  "",
    state_county:               "",
    postcode_zipcode:           "",
    country:                    "United Kingdom",
    contact_first_name:         "",
    contact_last_name:          "",
    contact_telephone_number:   "",
    contact_mobile_number:      "",
    contact_email:              "",
    notes:                      "",
}

const CreateEditSite = (props) => {
    const {
        customerId  = null,
        siteId      = null,
        onCancel    = () => {},
        onComplete  = () => {},
        onDelete    = () => {},
        parentId    = "",
    } = props;

    const [submitting, setSubmitting]               = useState(false);
    const [customer, setCustomer]                   = useState(false);
    const [errors, setErrors]                       = useState(null);
    const [site, setSite]                           = useState(SITE_DEFAULTS);
    const [archiveSiteModal, setArchiveSiteModal]   = useState(null);

    useEffect(() => {
        load();
    }, [siteId, customerId]);

    const load = () => {
        axios.get(route('web-api.customer.site.config', {customer: customerId, site_id: siteId}).toString())
        .then((response) => {
            if (!!response && !!response.data) {
                if (!!response.data.customer) {
                    setCustomer(response.data.customer);
                }

                if (!!response.data.site) {
                    setSite(response.data.site);
                }
            }
        })
        .catch((error) => {
            console.log(error);
            toast.error(<div>{"An error occurred"}</div>);
            setSubmitting(false);
        });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const reset = () => {
        setSite(SITE_DEFAULTS);

        setSubmitting(false);
        setErrors(null);
    }

    const payload = () => {
        return {
            method: !!siteId ? 'patch' : 'post',
            url:    !!siteId ? route('web-api.customer.site.update', {customer: customerId, site: siteId}).toString() : route('web-api.customer.site.store', {customer: customerId}).toString(),
            data: {
                name:                       site.name,
                address_line_1:             site.address_line_1,
                address_line_2:             site.address_line_2,
                address_line_3:             site.address_line_3,
                town_city:                  site.town_city,
                state_county:               site.state_county,
                postcode_zipcode:           site.postcode_zipcode,
                country:                    site.country,
                contact_first_name:         site.contact_first_name,
                contact_last_name:          site.contact_last_name,
                contact_telephone_number:   site.contact_telephone_number,
                contact_mobile_number:      site.contact_mobile_number,
                contact_email:              site.contact_email,
                notes:                      site.notes,
            },
        }
    }

    const submit = () => {
        axios(payload())
            .then((response) => {
                reset();
                onComplete(response.data.site_id);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }

                setSubmitting(false);
            });
    }

    const handleClose = () => {
        if (!submitting) {
            reset();
            onCancel();
        }
    }

    const onChange = (field, value) => {
        const clone = _.cloneDeep(site);

        switch (field) {
            case 'name':
                clone.name = value;
                break;
            case 'address_line_1':
                clone.address_line_1 = value;
                break;
            case 'address_line_2':
                clone.address_line_2 = value;
                break;
            case 'address_line_3':
                clone.address_line_3 = value;
                break;
            case 'town_city':
                clone.town_city = value;
                break;
            case 'state_county':
                clone.state_county  = value;
                break;
            case 'postcode_zipcode':
                clone.postcode_zipcode = value;
                break;
            case 'country':
                clone.country = value;
                break;
            case 'contact_first_name':
                clone.contact_first_name = value;
                break;
            case 'contact_last_name':
                clone.contact_last_name = value;
                break;
            case 'contact_telephone_number':
                clone.contact_telephone_number = value;
                break;
            case 'contact_mobile_number':
                clone.contact_mobile_number = value;
                break;
            case 'contact_email':
                clone.contact_email = value;
                break;
            case 'notes':
                clone.notes = value;
                break;
        }

        setSite(clone);
    }

    const handleCopyCustomer = () => {
        const clone = _.cloneDeep(site);

        if (!!customer) {
            clone.address_line_1              = customer.address_line_1;
            clone.address_line_2            = customer.address_line_2;
            clone.address_line_3            = customer.address_line_3;
            clone.town_city                 = customer.town_city;
            clone.state_county              = customer.state_county;
            clone.postcode_zipcode          = customer.postcode_zipcode;
            clone.country                   = customer.country;
            clone.contact_first_name        = customer.first_name;
            clone.contact_last_name         = customer.last_name;
            clone.contact_telephone_number  = customer.contact_telephone_number;
            clone.contact_mobile_number     = customer.contact_mobile_number;
            clone.contact_email             = customer.contact_email;
        }

        setSite(clone);
    }

    return (
        <React.Fragment>
            <div className={"mb-4"}>
                <div className="row m-0 p-0">
                    <div className="col-12 m-0 p-0 bespoke-input">
                        <Input
                            name={"name"}
                            label={"Site Name"}
                            required={true}
                            type={"text"}
                            value={site.name}
                            disabled={submitting}
                            onChange={(value) => onChange("name", value)}
                            error={!!errors && !!errors.name ? errors.name : null}
                        />
                    </div>
                </div>
            </div>
            <div className={"mb-4"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                    <h2 className="h6 mb-0 text-eh-navy">Main Address</h2>
                </div>
                <div className={"d-flex justify-content-start mb-3"}>
                    <Button
                        onClick={() => handleCopyCustomer()}
                        label={"Same As Customer Details"}
                        classes={"btn btn-eh-lilac px-3 m-0"}
                    />
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                        <Input
                            name={"address_line_1"}
                            label={"Address Line 1"}
                            required={false}
                            type={"text"}
                            value={site.address_line_1}
                            disabled={submitting}
                            onChange={(value) => onChange("address_line_1", value)}
                            error={!!errors && !!errors.address_line_1 ? errors.address_line_1 : null}
                        />
                    </div>
                    <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                        <Input
                            name={"address_line_2"}
                            label={"Address Line 2"}
                            required={false}
                            type={"text"}
                            value={site.address_line_2}
                            disabled={submitting}
                            onChange={(value) => onChange("address_line_2", value)}
                            error={!!errors && !!errors.address_line_2 ? errors.address_line_2 : null}
                        />
                    </div>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                        <Input
                            name={"address_line_3"}
                            label={"Address Line 3"}
                            required={false}
                            type={"text"}
                            value={site.address_line_3}
                            disabled={submitting}
                            onChange={(value) => onChange("address_line_3", value)}
                            error={!!errors && !!errors.address_line_3 ? errors.address_line_3 : null}
                        />
                    </div>
                    <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                        <Input
                            name={"town_city"}
                            label={"Town / City"}
                            required={false}
                            type={"text"}
                            value={site.town_city}
                            disabled={submitting}
                            onChange={(value) => onChange("town_city", value)}
                            error={!!errors && !!errors.town_city ? errors.town_city : null}
                        />
                    </div>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                        <Input
                            name={"state_county"}
                            label={"County / State"}
                            required={false}
                            type={"text"}
                            value={site.state_county}
                            disabled={submitting}
                            onChange={(value) => onChange("state_county", value)}
                            error={!!errors && !!errors.state_county ? errors.state_county : null}
                        />
                    </div>
                    <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                        <Input
                            name={"postcode_zipcode"}
                            label={"Postcode / Zipcode"}
                            required={false}
                            type={"postcode"}
                            value={site.postcode_zipcode}
                            disabled={submitting}
                            onChange={(value) => onChange("postcode_zipcode", value)}
                            error={!!errors && !!errors.postcode_zipcode ? errors.postcode_zipcode : null}
                        />
                    </div>
                </div>
                <div className="row m-0 p-0 mb-4">
                    <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                        <Input
                            name={"country"}
                            label={"Country"}
                            required={false}
                            type={"text"}
                            value={site.country}
                            disabled={submitting}
                            onChange={(value) => onChange("country", value)}
                            error={!!errors && !!errors.country ? errors.country : null}
                        />
                    </div>
                </div>
            </div>
            <div className={"mb-4"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                    <h2 className="h6 mb-0 text-eh-navy">Main Contact</h2>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                        <Input
                            name={"contact_first_name"}
                            label={"First Name"}
                            required={true}
                            type={"text"}
                            value={site.contact_first_name}
                            disabled={submitting}
                            onChange={(value) => onChange("contact_first_name", value)}
                            error={!!errors && !!errors.contact_first_name ? errors.contact_first_name : null}
                        />
                    </div>
                    <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                        <Input
                            name={"contact_last_name"}
                            label={"Last Name"}
                            required={true}
                            type={"text"}
                            value={site.contact_last_name}
                            disabled={submitting}
                            onChange={(value) => onChange("contact_last_name", value)}
                            error={!!errors && !!errors.contact_last_name ? errors.contact_last_name : null}
                        />
                    </div>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                        <Input
                            name={"contact_telephone_number"}
                            label={"Telephone Number"}
                            required={false}
                            type={"text"}
                            value={site.contact_telephone_number}
                            disabled={submitting}
                            onChange={(value) => onChange("contact_telephone_number", value)}
                            error={!!errors && !!errors.contact_telephone_number ? errors.contact_telephone_number : null}
                        />
                    </div>
                    <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                        <Input
                            name={"contact_mobile_number"}
                            label={"Mobile Number"}
                            required={false}
                            type={"text"}
                            value={site.contact_mobile_number}
                            disabled={submitting}
                            onChange={(value) => onChange("contact_mobile_number", value)}
                            error={!!errors && !!errors.contact_mobile_number ? errors.contact_mobile_number : null}
                        />
                    </div>
                </div>
                <div className="row m-0 p-0">
                    <div className="col-12 m-0 p-0 bespoke-input">
                        <Input
                            name={"contact_email"}
                            label={"Email"}
                            required={false}
                            type={"email"}
                            value={site.contact_email}
                            disabled={submitting}
                            onChange={(value) => onChange("contact_email", value)}
                            error={!!errors && !!errors.contact_email ? errors.contact_email : null}
                        />
                    </div>
                </div>
            </div>
            <div className={"mb-4"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                    <h2 className="h6 mb-0 text-eh-navy">Additional</h2>
                </div>
                <div className="row m-0 mb-4 p-0">
                    <div className="col-12 m-0 p-0 bespoke-input">
                        <Input
                            name={"notes"}
                            label={"Notes"}
                            required={false}
                            type={"textarea"}
                            value={site.notes}
                            disabled={submitting}
                            onChange={(value) => onChange("notes", value)}
                            error={!!errors && !!errors.notes ? errors.notes : null}
                        />
                    </div>
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center">
                        <Button
                            onClick={() => setSubmitting(true)}
                            label={!!siteId ? "Save Changes" : "Create Site"}
                            classes={"btn btn-eh-lilac m-0 mr-4"}
                        />
                        <Button
                            onClick={() => handleClose()}
                            label={"Cancel"}
                            classes={"btn btn-outline-eh-off-black m-0 mr-4"}
                        />
                    </div>
                    {!!siteId && !!site && !!site.can && site.can.delete === true && (
                        <Button
                            onClick={() => setArchiveSiteModal(site)}
                            label={"Delete Site"}
                            classes={"btn btn-danger m-0"}
                        />
                    )}
                </div>
            </div>
            <ArchiveSiteModal
                show={!!archiveSiteModal}
                site={!!archiveSiteModal ? archiveSiteModal : null}
                parentId={parentId}
                onCancel={() => setArchiveSiteModal(null)}
                onConfirm={() => onDelete()}
            />
        </React.Fragment>
    );
}

export default CreateEditSite;
